export type Quantity = number & { readonly __brand: 'Quantity' };

export function quantity(value: number): Quantity {
  if (!Number.isInteger(value) || value < 0) {
    throw new Error(`Invalid Quantity: ${value}`);
  }
  return value as Quantity;
}
